import { PlusIcon } from "@heroicons/react/solid";
import { MeetingViewMeetingNodeNewPageFragmentFragment } from "types/graphql-schema";

import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";

import { createTopicInMeeting } from "../helpers";

const AddTopicHover = ({
  meeting,
  afterTopicId,
  beforeTopicId,
  hideButton = false,
}: {
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
  afterTopicId?: number;
  beforeTopicId?: number;
  hideButton?: boolean;
}) => {
  const handleClickAdd = () => {
    createTopicInMeeting({
      meeting,
      afterTopicId,
      beforeTopicId,
    });
  };

  if (!meeting.canUpdate?.permission) return null;

  return (
    <div
      className={
        hideButton
          ? "relative h-px pt-3 pb-6 w-full group/add-topic"
          : "relative h-px py-6 w-full group/add-topic"
      }
    >
      <div className="h-px bg-gray-200" />
      {!hideButton && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover/add-topic:opacity-100">
          <Button
            onClick={handleClickAdd}
            size={ButtonSize.medium}
            className="gap-1 tracking-tight"
          >
            <PlusIcon className="w-4 h-4" />
            Add Topic
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddTopicHover;
